(ns yardwerkz.web.app
  "Entry point for the Yardwerkz web customer app.
   Sets up ClerkProvider, RFX store, reitit router, and the app shell."
  (:require
   [uix.core :refer [defui $]]
   [uix.dom]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.auth :as auth]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   ;; Page components
   [yardwerkz.web.booking.wizard :as booking]
   [yardwerkz.web.jobs.list :as jobs-list]
   [yardwerkz.web.jobs.detail :as jobs-detail]
   [yardwerkz.web.messages.inbox :as messages]
   [yardwerkz.web.profile.hub :as profile-hub]
   [yardwerkz.web.profile.saved-addresses :as saved-addresses]
   [yardwerkz.web.profile.edit-profile :as edit-profile]
   [yardwerkz.web.profile.payment-methods :as payment-methods]
   [yardwerkz.web.profile.payment-history :as payment-history]
   [yardwerkz.web.profile.notification-prefs :as notification-prefs]
   [lambdaisland.glogi :as log]
   [lambdaisland.glogi.console :as glogi-console]))

;; =============================================================================
;; Logging Setup
;; =============================================================================

(glogi-console/install!)
(log/set-levels {:glogi/root :info})

;; =============================================================================
;; Route → View Dispatch
;; =============================================================================

(defn- route-view
  "Map a route match to the corresponding page component."
  [route-match]
  (let [route-name (some-> route-match :data :name)]
    (case route-name
      :home             ($ booking/wizard-page)
      :book             ($ booking/wizard-page)
      :jobs             ($ jobs-list/list-page)
      :job              ($ jobs-detail/detail-page {:route-match route-match})
      :messages         ($ messages/inbox-page)
      :conversation     ($ messages/inbox-page)
      :profile          ($ profile-hub/hub-page)
      :saved-addresses  ($ saved-addresses/saved-addresses-page)
      :edit-profile     ($ edit-profile/edit-profile-page)
      :payment-methods  ($ payment-methods/payment-methods-page)
      :payment-history  ($ payment-history/payment-history-page)
      :notification-prefs ($ notification-prefs/notification-prefs-page)
      ;; Default
      ($ booking/wizard-page))))

;; =============================================================================
;; Root Component
;; =============================================================================

(defui app []
  (let [route-match (rfx/use-sub [::store/current-route])]
    ($ auth/clerk-provider
       ($ ui/error-boundary
          ($ auth/auth-gate
             ($ layout/app-shell
                (route-view route-match)))))))

;; =============================================================================
;; Initialization
;; =============================================================================

(defn ^:export init []
  (log/info :app/init {:version "0.1.0"})
  ;; Initialize router
  (router/init!)
  ;; Mount React app
  (let [root (uix.dom/create-root (js/document.getElementById "app"))]
    (uix.dom/render-root
     ($ rfx/RfxContextProvider #js {:value store/rfx-ctx}
        ($ app))
     root)))
